export enum AIApps {
  ASSIST = 'Assist',
  NOTETAKER = 'NoteTaker'
}
